export default {
  common: {
    read_bio: 'Read bio',
  },
};
